import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getLocalStorageObject } from "../util/helper";
import { useToast } from "components/common/custom-toast/Toast";

const BrokerProtectedRoute = ({ component: Component }) => {
  const isLoggedIn = useSelector((state) => state?.user?.isLoggedIn === true);
  const isBrokersLoading = useSelector((state) => state?.brokers?.isLoading);
  const isPlansLoading = useSelector((state) => state?.packages?.isLoading);
  const toast = useToast();

  const user = getLocalStorageObject("user");
  const isBrokerLoggedIn = user?.brokerLoggedIn === true;

  useEffect(() => {
    if (!isBrokersLoading && !isPlansLoading && isLoggedIn && !isBrokerLoggedIn) {
      toast.error("Please connect your broker account to access this page");
    }
  }, [isLoggedIn, isBrokerLoggedIn, isBrokersLoading, isPlansLoading]);

  if (!isLoggedIn) {
    return <Navigate to="/authentication/login" replace />;
  }

  if (isBrokersLoading || isPlansLoading) {
    return null; // or a loading spinner
  }

  if (!isBrokerLoggedIn) {
    return <Navigate to="/broker-login" replace />;
  }

  return <Component />;
};

export default BrokerProtectedRoute;
